'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.controller('PensionModulesCtrl', function(PensionModulesStore, $scope) {

  var self = this;

  this.modules = PensionModulesStore.getModules();
  this.modulePairs = _generateModulePairs(this.modules);

  if (this.modules.length === 0) {
    this.pleaseWaitMessage = true;
  }

  var unique = PensionModulesStore.onUpdate('PensionModulesCtrl', function() {
    self.modules = PensionModulesStore.getModules();
    self.modulePairs = _generateModulePairs(self.modules);
    self.pleaseWaitMessage = false;
  }, false, true);

  function _generateModulePairs(modules) {
    var pairs = [];
    for (var i = 0; i < modules.length; i += 2) {
      var idx = i / 2;
      pairs[idx] = {};
      pairs[idx].first = _generateModuleInformation(modules[i]);
      if (modules[i + 1]) {

        pairs[idx].second = _generateModuleInformation(modules[i + 1]);
      }
    }
    return pairs;
  };

  this.generateModulePairs = _generateModulePairs;

  function _generateModuleInformation(module) {
    if (module === undefined) {
      return;
    }
    if (module.details === undefined) {
      module.details = setDefaultDetails();
    }

    var header = createHeaderKey(module.moduleName);
    var prefix, key;

    if (hasAlert(module)) {
      prefix = 'alerts';
      key = module.details.alertType;
    } else if (hasTextKey(module)) {
      prefix = header;
      key = module.details.attributes.key;
    } else {
      prefix = header;
      key = 'default';
    }

    var moduleDetails = {
      moduleName: module.moduleName,
      alertType: module.details.alertType,
      alertCount: module.details.alertCount,
      attributes: module.details.attributes,
      header: header,
      text: prefix + '.' + key + '.text',
      button: prefix + '.' + key + '.button',
      href: prefix + '.' + key + ((hasAlert(module)) ? '.hrefOnPensionPage' : '.href'),
      headerHref: getHeaderHref(module)
    };

    return moduleDetails;
  };

  this.generateModuleInformation = _generateModuleInformation;

  function setDefaultDetails() {
    var defaultDetails = {
      alertType: null,
      alertCount: 0,
      attributes: {}
    };
    return defaultDetails;
  };

  function createHeaderKey(moduleName) {
    var key = moduleName.replace('-', '.');
    if (key.indexOf('pension.') === -1) {
      key = 'pension.' + key;
    }
    return key;
  };

  function hasAlert(module) {
    return module.details && module.details.alertType;
  };

  function hasTextKey(module) {
    return module.details && module.details.attributes && module.details.attributes.key;
  };

  function getHeaderHref(module) {
    if (hasAlert(module)) {
      return getHeaderHrefWithAlerts(module);
    }
    else {
      return getHeaderHrefNoAlerts(module);
    }
  };

  function getHeaderHrefWithAlerts(module) {
    if (module.details.attributes && module.details.attributes.key ==='isPurchasingBuybackInCurrentSchoolYear') {
      return 'modulesWithAlerts.' + module.moduleName + '-unavailable.href';
    }
    else {
      return 'modulesWithAlerts.' + module.moduleName + '.href';
    }
  };

  function getHeaderHrefNoAlerts(module) {
    if (module.details.attributes && module.details.attributes.key ==='isPurchasingBuybackInCurrentSchoolYear') {
      return 'modules.' + module.moduleName + '-unavailable.href';
    }
    else {
      return 'modules.' + module.moduleName + '.href';
    }
  }

  $scope.$on('$destroy', function() {
    PensionModulesStore.deregister(unique);
  });

});

